import React from 'react';
import { Link } from 'react-router-dom';
import ronImg from '../Images/Ron_templeman.jpg';
import vladImg from '../Images/Vlad_tyshchenko.jpg';
import christineImg from '../Images/Christine_perrault.jpg';

const Company = () => {
  const teamMembers = [
    {
      name: 'Ron Templeman',
      role: 'CEO & Director',
      image: ronImg,
      // Focus: 20% from the top (stops head from being cut off)
      focus: '50% 20%', 
      expertise: ['Database Modeling', 'Data Architect', 'System Design'],
      description: 'A seasoned expert in statistical data analysis with a Bachelor of Science in Mathematics from the University of Saskatchewan. Ron bridges the gap between pure mathematical logic and enterprise data management. Since 1986, he has mentored emerging professionals and guided institutional clients through complex decision-making frameworks.',
    },
    {
      name: 'Vlad Tyshchenko',
      role: 'Lead Software Architect',
      image: vladImg,
      focus: 'center',
      expertise: ['Full-Stack Engineering', 'System Modernization', 'API Design'],
      description: 'Holding a Master’s degree in Software Engineering, Vladyslav specializes in architecting high-performance, full-stack environments. He leads the technical execution of our custom software solutions, ensuring that every line of code serves the broader goal of system stability and scalability.',
    },
    {
      name: 'Christine Perrault',
      role: 'Technical Operations & Interface Specialist',
      image: christineImg,
      // Focus: center
      focus: 'center', 
      expertise: ['Linux Administration', 'UI/UX Design', 'Systems Security'],
      description: 'Christine manages the essential framework of Yellow Ray’s technical operations and user experience. Her work spans the administration of Linux server environments and security protocols to the design and implementation of application interfaces and web platforms. By balancing organizational management with technical oversight, she ensures the ongoing system integrity, security, and operational standards of the firm.'
    }
  ];

  return (
    <div style={{ backgroundColor: '#fff', color: '#0f172a', fontFamily: 'Inter, sans-serif' }}>
      
      {/* ================= 1. HISTORY SECTION (THE LEGACY) ================= */}
      <section style={historySection}>
        <div style={container}>
          <span style={eyebrow}>Our Foundation</span>
          <h1 style={mainTitle}>Engineering Legacies <br/>Since 1986</h1>
          <div style={historyCard}>
            <p style={historyText}>
              Formerly known as <strong>Optima Research Inc.</strong> and <strong>Templeman Consulting</strong>, Yellow Ray Consulting Group has been a cornerstone of data-driven insights for nearly four decades. 
            </p>
            <p style={historyText}>
              What began as a specialized statistical firm has evolved into a comprehensive systems architecture group. We have spent 35+ years refining our approach to data governance, stewardship, and relational modeling—helping institutions move from fragmented information to operational certainty.
            </p>
          </div>
        </div>
      </section>

      {/* ================= 2. TEAM SECTION ================= */}
      <section style={teamSection}>
        <div style={container}>
          <h2 style={sectionTitle}>Our Team</h2>
          <div style={teamGrid}>
            {teamMembers.map((member, index) => (
              <div key={index} style={teamCard}>
                <div style={imageWrapper}>
                  <img 
                    src={member.image} 
                    alt={member.name} 
                    style={{ 
                      ...memberImage, 
                      objectPosition: member.focus // Individually positions each headshot
                    }} 
                  />
                  {/* Subtle gradient overlay to hide lower-res blurriness */}
                  <div style={imageOverlay}></div>
                </div>
                
                <h3 style={memberName}>{member.name}</h3>
                <div style={memberRole}>{member.role}</div>
                
                <div style={badgeContainer}>
                  {member.expertise.map((skill, i) => (
                    <span key={i} style={skillBadge}>{skill}</span>
                  ))}
                </div>

                <p style={memberDesc}>{member.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= 3. CLOSING CALL TO ACTION ================= */}
      <section style={ctaSection}>
  <h2 style={{ fontSize: '24px', marginBottom: '15px' }}>
    Put our expertise to work for your organization.
  </h2>
  
  {/* Changed from <button> to <Link> */}
  <Link 
    to="/case-studies" 
    style={{ 
      ...ctaButton, 
      textDecoration: 'none', 
      display: 'inline-block' 
    }}
  >
    View Our Case Studies
  </Link>
</section>
    </div>
  );
};

// ================= STYLES =================

const container = { maxWidth: '1150px', margin: '0 auto', padding: '0 20px' };

const eyebrow = {
  color: '#007bff',
  fontWeight: '800',
  fontSize: '12px',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  display: 'block',
  marginBottom: '15px'
};

const historySection = {
  padding: '100px 0',
  backgroundColor: '#f8fafc',
  textAlign: 'center',
  borderBottom: '1px solid #e2e8f0'
};

const mainTitle = { fontSize: '48px', fontWeight: '900', marginBottom: '30px', lineHeight: '1.1' };

const historyCard = {
  maxWidth: '800px',
  margin: '0 auto',
  textAlign: 'left',
  backgroundColor: '#fff',
  padding: '40px',
  borderRadius: '16px',
  boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)',
  border: '1px solid #e2e8f0'
};

const historyText = { fontSize: '17px', color: '#475569', lineHeight: '1.7', marginBottom: '20px' };

const teamSection = { padding: '100px 0', textAlign: 'center' };

const sectionTitle = { fontSize: '32px', fontWeight: '800', marginBottom: '60px' };

const teamGrid = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
  gap: '40px', 
  marginTop: '40px'
};

const teamCard = {
  textAlign: 'left',
  padding: '15px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
};

const imageWrapper = {
  position: 'relative', // Necessary for the overlay
  width: '200px',      // Slightly smaller width to keep images sharp
  height: '260px',     // Taller height (Portrait) handles headshots better
  borderRadius: '12px', 
  overflow: 'hidden',
  marginBottom: '25px',
  backgroundColor: '#f1f5f9',
  border: '1px solid #e2e8f0',
  boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.05)'
};



const memberImage = { 
  width: '100%', 
  height: '100%', 
  objectFit: 'cover',
  display: 'block'
};

const imageOverlay = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(to bottom, transparent 60%, rgba(15, 23, 42, 0.05) 100%)',
  pointerEvents: 'none'
};

const memberName = { fontSize: '22px', fontWeight: '800', marginBottom: '5px', color: '#0f172a' };

const memberRole = { fontSize: '14px', fontWeight: '700', color: '#007bff', marginBottom: '15px', textTransform: 'uppercase' };

const badgeContainer = { display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '20px' };

const skillBadge = {
  fontSize: '11px',
  fontWeight: '700',
  backgroundColor: '#f1f5f9',
  color: '#475569',
  padding: '4px 10px',
  borderRadius: '4px'
};

const memberDesc = { fontSize: '15px', color: '#64748b', lineHeight: '1.6' };

const ctaSection = {
  padding: '80px 20px',
  textAlign: 'center',
  backgroundColor: '#0f172a',
  color: '#fff'
};

const ctaButton = {
  backgroundColor: '#007bff',
  color: '#fff',
  padding: '14px 28px',
  borderRadius: '6px',
  border: 'none',
  fontWeight: '700',
  cursor: 'pointer'
};

export default Company;